<template>
  <div class="logistics1">
    <top-nav1 ref="TopNav1"></top-nav1>
    <van-nav-bar style="background: #F1F1F1"  title="物流信息" fixed left-arrow @click-left="goBack" >
      <van-icon @click="onClickRight" slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div style="padding-bottom: 0;padding-top:46px;" class="van-content">
      <div class="card" >
        <div style="line-height: 29px"><span style="display: inline-block;line-height: 29px;height: 29px;">物流公司：{{ datas.name }}</span></div>
        <div style="line-height: 29px"><span style="display: inline-block;line-height: 29px;height: 29px;">物流单号：{{ datas.code}}</span></div>
      </div>
      <div style="padding: 0 15px;background: #fff">
        <img src="/static/images/eline.png" alt="">
      </div>
      <van-cell-group style="margin-bottom: 0">
        <van-steps direction="vertical" :active="0" active-color="#06bf04">
          <van-step v-for="(items,index) in data" :key="items.id">
            <p  :class="{'theme-col': index == 0}">{{ items.context }}</p>
            <p style="font-size: .24rem" :class="{'theme-col': index == 0}">{{ items.time }}</p>
          </van-step>
        </van-steps>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/topnav";
import TopNav1 from "../../components/topnav1";
export default {
  name: "logistics",
  components: {
    TopNav1
  },
  data() {
    return {
      datas: "",
      data: [],
      orderId: this.$route.query.orderid,
      gid: this.$route.query.gid
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav1.topnavPlay();
    },
    getDatas: function() {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      this.$api.post(
        "active/order/logistics",
        { id_active: this.gid, token_user: isUser, id_order: this.orderId },
        res => {
          if (res.data.code == "100") {
            this.datas = res.data.data;
            var _this = this;
            if (res.data.data.item.length != 0) {
              for (let i = 0; i < res.data.data.item.length; i++) {
                _this.data.push(res.data.data.item[i]);
              }
            }
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({
                    name: "Elogin",
                    query: { gid: this.gid }
                  });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    }
  },
  mounted() {
    this.getDatas();
    $("body").css("background", "#fff");
  },
  destroyed: function() {
    $("body").css("background", "#EFF3F6");
  }
};
</script>

<style lang="less" >
.logistics1 {
  .van-nav-bar .van-icon {
    font-size: 0.4rem !important;
  }
  .van-hairline--bottom.van-nav-bar.van-nav-bar--fixed {
    .van-nav-bar__title {
      text-align: center !important;
      font-weight: bold !important;
    }
  }
  .van-cell-group {
    background-color: #fff;
  }
  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
  .van-step--vertical p {
    margin-bottom: 10px;
    color: #aeaeae;
  }
  .card {
    background-color: #fff;
    height: 65px;
    padding-left: 15px;
    padding-top: 10px;
  }
  .van-step--vertical:not(:last-child)::after {
    border-bottom-width: 0;
  }
  .van-step--vertical .van-step__circle {
    left: -18px;
  }
  .van-step .van-step__circle {
    display: block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #ebedf0;
  }
  .expressName {
    display: inline-block;
    width: 25px;
    height: 29px;
    background: url("/static/images/express1.png") no-repeat center;
    background-size: 99% 60%;
    margin-right: 10px;
    vertical-align: middle;
  }
  .expressNum {
    display: inline-block;
    width: 25px;
    height: 29px;
    background: url("/static/images/express2.png") no-repeat center;
    background-size: 80% 82%;
    margin-right: 10px;
    vertical-align: middle;
  }
  .van-steps--vertical {
    padding: 0 0 15px 35px !important;
  }
  .van-nav-bar {
    .van-icon {
      font-size: 0.4 !important;
    }
  }
}
.theme-bg,
.van-checkbox--checked,
.van-swipe__indicator--active {
  background-color: red !important;
  color: #ffffff !important;
}
.theme-col,
.van-icon-checked {
  color: red !important;
}
.col-hover:hover {
  color: red !important;
}
.col-on {
  color: red !important;
}
.col-focus:focus {
  color: red !important;
}
.col-checked:checked:before {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/logistics.vue